const ADMIN = "admin";
const CLIENT = "client";

const DOMAIN_SEX = "Sexo";
const DOMAIN_DOC_TYPE = "Tipo de Documento";
const DOMAIN_PLAN_TYPE = "Tipo de Plan Mobil";
const DOMAIN_HOW_FIND_US = "¿Cómo nos encontraste?";
const DOMAIN_SOCIOECONOMIC_LEVEL = "Nivel Socioeconomico";
const DOMAIN_STUDY_LEVEL = "Nivel de estudio";
const DOMAIN_VEHICLE_TYPE = "Tipo de Vehículo";
const DOMAIN_CIVIL_STATUS = "Estado Civil";
const DOMAIN_INCOME_SALARY = "Rango salarial";
const DOMAIN_EXPENSES = "Rango de gastos";
const DOMAIN_REF_P_RELATION = "Relación Referencia Personal";
const DOMAIN_REF_F_RELATION = "Relación Referencia Familiar";
const DOMAIN_LIVE_WITH = "¿Con quién vive?";
const DOMAIN_EMPLOYMENT = "Ocupación Actual";
const DOMAIN_BANKS = "Banco";
const DOMAIN_ENTERPRISE_SECTOR = "Sector de la empresa";
const DOMAIN_CONTRACT_TYPE = "Tipo de contrato";
const DOMAIN_TICKET_TYPE = "Tipo de ticket";
const DOMAIN_START_ADRESS = "Inicio Dirección";
const DOMAIN_ORIENTATION_ADRESS = "Orientación Dirección";
const DOMAIN_PARTITION_ADRESS = "Partición Dirección";

const OTHER_TICKET_TYPE = 285;
const EMAIL_TICKET_TYPE_VALUE = "Configuración Correo Electrónico";

const CONFIG_ID_IVA = 1;
const CONFIG_ID_TECHNOLOGY_PER_DAY = 2;
const CONFIG_ID_INTERESTS_PERCENTAGE = 3;
const CONFIG_ID_SECURITY_BY_MILLION = 4;
const CONFIG_ID_CREDIT_QUANTITY_MAX = 5;
const CONFIG_ID_CREDIT_QUANTITY_MIN = 6;
const CONFIG_ID_CREDIT_QUANTITY_PIVOT = 7;

const STATUS_CLIENT_NEW = 11;
const STATUS_CLIENT_REKOGNIZED = 12;
const STATUS_CLIENT_ACTIVE = 13;
const STATUS_CLIENT_NOT_MIGRATED = 14;
const STATUS_CLIENT_BLOCKED = 15;

const STATUS_CREDIT_NEW = 21;
const STATUS_CREDIT_IN_PROGRESS = 22;
const STATUS_CREDIT_PRE_APPROVED = 23;
const STATUS_CREDIT_APPROVED = 24;
const STATUS_CREDIT_OWED = 25;
const STATUS_CREDIT_IN_ARREARS = 26;
const STATUS_CREDIT_DENIED = 27;
const STATUS_CREDIT_PAY_AGREEMENT = 28;
const STATUS_CREDIT_PAID = 29;

const STATUS_TICKET_CLOSED = 32;

const KEY_NAME_REASON_DOCUMENT_PICTURE = "DocumentPicture";
const KEY_NAME_REASON_DOCUMENT_PICTURE_BACK = "DocumentPictureBack";
const KEY_NAME_REASON_RECOGNITION_PICTURE = "RecognitionPicture";
const KEY_NAME_REASON_BANK_CERTIFICATE = "BankCertificate";
const KEY_NAME_REASON_WORK_CERTIFICATE = "WorkCertificate";
const KEY_NAME_REASON_PAY_STUB = "PayStub";

const APOLLO_TOKEN = "apollo-token";
const USER = "user";
const CREDIT_MAX_VALUE = "credit-max-value"

const CREDIT_VALUE = "creditValue";
const CREDIT_DAYS = "creditTime";

const BENEFIT_ADMIN = 2;
const BENEFIT_TECH = 3;

import { onLogout } from "./vue-apollo.js";
import Swal from "sweetalert2";

export default {
  ADMIN,
  CLIENT,

  DOMAIN_SEX,
  DOMAIN_DOC_TYPE,
  DOMAIN_PLAN_TYPE,
  DOMAIN_HOW_FIND_US,
  DOMAIN_SOCIOECONOMIC_LEVEL,
  DOMAIN_STUDY_LEVEL,
  DOMAIN_VEHICLE_TYPE,
  DOMAIN_CIVIL_STATUS,
  DOMAIN_INCOME_SALARY,
  DOMAIN_EXPENSES,
  DOMAIN_REF_P_RELATION,
  DOMAIN_REF_F_RELATION,
  DOMAIN_LIVE_WITH,
  DOMAIN_EMPLOYMENT,
  DOMAIN_BANKS,
  DOMAIN_ENTERPRISE_SECTOR,
  DOMAIN_CONTRACT_TYPE,
  DOMAIN_TICKET_TYPE,
  DOMAIN_START_ADRESS,
  DOMAIN_ORIENTATION_ADRESS,
  DOMAIN_PARTITION_ADRESS,

  OTHER_TICKET_TYPE,
  EMAIL_TICKET_TYPE_VALUE,

  CONFIG_ID_IVA,
  CONFIG_ID_TECHNOLOGY_PER_DAY,
  CONFIG_ID_INTERESTS_PERCENTAGE,
  CONFIG_ID_SECURITY_BY_MILLION,
  CONFIG_ID_CREDIT_QUANTITY_MAX,
  CONFIG_ID_CREDIT_QUANTITY_MIN,
  CONFIG_ID_CREDIT_QUANTITY_PIVOT,

  STATUS_CLIENT_NEW,
  STATUS_CLIENT_REKOGNIZED,
  STATUS_CLIENT_ACTIVE,
  STATUS_CLIENT_NOT_MIGRATED,
  STATUS_CLIENT_BLOCKED,

  STATUS_CREDIT_NEW,
  STATUS_CREDIT_IN_PROGRESS,
  STATUS_CREDIT_PRE_APPROVED,
  STATUS_CREDIT_APPROVED,
  STATUS_CREDIT_OWED,
  STATUS_CREDIT_IN_ARREARS,
  STATUS_CREDIT_DENIED,
  STATUS_CREDIT_PAY_AGREEMENT,
  STATUS_CREDIT_PAID,

  STATUS_TICKET_CLOSED,

  KEY_NAME_REASON_DOCUMENT_PICTURE,
  KEY_NAME_REASON_DOCUMENT_PICTURE_BACK,
  KEY_NAME_REASON_RECOGNITION_PICTURE,
  KEY_NAME_REASON_BANK_CERTIFICATE,
  KEY_NAME_REASON_WORK_CERTIFICATE,
  KEY_NAME_REASON_PAY_STUB,

  APOLLO_TOKEN,
  USER,
  CREDIT_MAX_VALUE,

  CREDIT_VALUE,
  CREDIT_DAYS,


  BENEFIT_ADMIN,
  BENEFIT_TECH,

  currencyValue(value) {
    var colombianCurrency = {
      style: "currency",
      currency: "COP",
      maximumSignificantDigits: 6
    };
    if (!value) value = 0;
    return new Intl.NumberFormat("es-CO", colombianCurrency).format(
      Math.floor(value)
    );
  },
  catchError(error, apolloClient, father, stayPage) {
    var errorMessage = null;

    if (
      error.graphQLErrors &&
      error.graphQLErrors[0] &&
      error.graphQLErrors[0].message.endsWith("Access is denied")
    )
      errorMessage = "No tienes permisos para acceder a esta página";
    else if (error.graphQLErrors && error.graphQLErrors[0])
      errorMessage = error.graphQLErrors[0].message;
    else if (
      error.networkError &&
      `${error.networkError}`.endsWith("status code 500") &&
      !stayPage
    )
      errorMessage =
        "Su sesión ha expirado, ingresa los credenciales e inténtalo de nuevo.";
    else if (
      error.networkError &&
      `${error.networkError}`.endsWith("status code 500") &&
      stayPage
    )
      errorMessage = "Su sesión ha expirado, continúa para refrescar.";
    else if (error.networkError)
      errorMessage =
        "Ha ocurrido un error desde el servidor, por favor ingresa más tarde.";
    else if (error.response && error.response.data)
      errorMessage = error.response.data;

    Swal.fire({
      title: "Error",
      text: errorMessage,
      confirmButtonClass: "md-button md-danger",
      buttonsStyling: false
    }).then(() => {
      if (
        (error.networkError && !stayPage) ||
        (error.graphQLErrors &&
          error.graphQLErrors[0] &&
          error.graphQLErrors[0].message.endsWith("Access is denied"))
      ) {
        onLogout(apolloClient);
        father.$router.push(
          "/login/" + father.$route.path.replaceAll("/", " ")
        );
      } else if (error.networkError && stayPage) {
        onLogout(apolloClient);
        father.$router.go();
      }
    });
  },
  getUserId() {
    if (JSON.parse(localStorage.getItem(USER)) != null)
      return JSON.parse(localStorage.getItem(USER)).userId;
    else return null;
  },
  hasProfile() {
    if (JSON.parse(localStorage.getItem(USER)) != null)
      return JSON.parse(localStorage.getItem(USER)).hasProfile;
    else return null;
  },
  getUserDocumentValue() {
    if (JSON.parse(localStorage.getItem(USER)) != null)
      return JSON.parse(localStorage.getItem(USER)).documentValue;
    else return null;
  },
  getUserType() {
    if (JSON.parse(localStorage.getItem(USER)) != null)
      return JSON.parse(localStorage.getItem(USER)).userType;
    else return null;
  },
  getUserFullName() {
    var user = JSON.parse(localStorage.getItem(USER));
    if (user != null) return user.firstName + " " + user.lastName;
    else return null;
  },
  formatDate(input) {
    var dateInArray = input.split("-");
    var fecha = new Date(dateInArray[0], dateInArray[1] - 1, dateInArray[2]);
    var options = { year: "numeric", month: "long", day: "numeric" };
    return fecha.toLocaleDateString("es-ES", options);
  },
  formatDateJS(input) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return input.toLocaleDateString("es-ES", options);
  },
  daysOfDifference(date1, date2) {
    // To calculate the time difference of two dates
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
    return Difference_In_Days;
  },
  formatAMPM(date) {
    var hours = date.split(":")[0];
    var minutes = date.split(":")[1];
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
};
